import cnpj from './cnpj'

import cpf from './cpf'

export default (str) => {
  const normalized = String(str || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')

  if (/[A-Z]/.test(normalized) || normalized.length > 11) return cnpj(normalized)

  return cpf(normalized.replace(/[^0-9]/g, ''))
}
